module.exports = __webpack_public_path__ + "static/media/linc-mic.ec670d96.png";